import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import config from '../common/config';
import { AnnouncementResponse } from '../components/announcements/common';

const CACHE_SETTINGS = {
	staleTime: 5 * 60 * 1000, // 5min — announcements are static
	gcTime: 10 * 60 * 1000,
	refetchOnMount: false,
	refetchOnWindowFocus: false
};

async function getTableAnnouncementsByRestaurant(id: string): Promise<Record<string, AnnouncementResponse>> {
	const response = await fetch(`${config.adminApiHost}/tables/announcements?restaurantId=${id}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json'
		}
	});

	const announcements = await response.json();
	return announcements;
}

export function useTableAnnouncementsByRestaurant(id: string) {
	return useQuery({
		enabled: !!id,
		queryKey: ['getTableAnnouncementsByRestaurant', id],
		queryFn: () => getTableAnnouncementsByRestaurant(id),
		...CACHE_SETTINGS
	});
}

export function useTableAnnouncementsByRestaurantSuspense(id: string) {
	return useSuspenseQuery({
		queryKey: ['getTableAnnouncementsByRestaurant', id],
		queryFn: () => getTableAnnouncementsByRestaurant(id),
		...CACHE_SETTINGS
	});
}
